import type { AxiosError } from 'axios';
import { createQuery } from 'react-query-kit';

import { client } from '@/api/common';
import type { AdminReservation } from '@/api/reservations';

type Variables = { id: number };
type Response = AdminReservation;

export const useReservation = createQuery<Response, Variables, AxiosError>({
  queryKey: ['reservations/partner/id'],
  fetcher: ({ id }) => {
    return client
      .get(`v2/internal/partners/reservations/${id}`)
      .then((response) => {
        return response.data.data;
      });
  },
});
